import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';

export const drawerAnimations = [
  trigger('slideInFromRight', [
    state(
      'closed',
      style({
        transform: 'translateX(100%)',
        visibility: 'hidden',
      }),
    ),
    state(
      'open',
      style({
        transform: 'translateX(0)',
        visibility: 'visible',
      }),
    ),
    transition('closed => open', [
      style({ visibility: 'visible' }),
      animate(
        '300ms cubic-bezier(0.25, 0.8, 0.25, 1)',
        style({
          transform: 'translateX(0)',
        }),
      ),
    ]),
    transition('open => closed', [
      animate(
        '300ms cubic-bezier(0.25, 0.8, 0.25, 1)',
        style({
          transform: 'translateX(100%)',
        }),
      ),
      style({ visibility: 'hidden' }),
    ]),
  ]),
  trigger('backdropFade', [
    state(
      'hidden',
      style({
        opacity: 0,
        visibility: 'hidden',
      }),
    ),
    state(
      'visible',
      style({
        opacity: 1,
        visibility: 'visible',
      }),
    ),
    transition('hidden => visible', [
      style({ visibility: 'visible' }),
      animate(
        '200ms ease-out',
        style({
          opacity: 1,
        }),
      ),
    ]),
    transition('visible => hidden', [
      animate(
        '200ms ease-in',
        style({
          opacity: 0,
        }),
      ),
      style({ visibility: 'hidden' }),
    ]),
  ]),
];
